import styled from '@emotion/styled';
import { mapStylesProp } from 'utils/styles';

export const TrUI = styled('tr')(mapStylesProp);
